module.exports = __webpack_public_path__ + "static/media/project-icon-tindog.e2678237.png";